import {
  contractorMonitoringPerformanceTestStatusOptions,
  deviceAccessoriesOptions,
  devicesAlertsOptions,
  devicesMembershipOptions,
  deviceSystemTypeOptions,
  deviceWorkStatusOptions,
  hvacOptions,
} from "constants/SelectFieldOptions"
import { UITypes } from "types"

import { CustomerMembershipType } from "components/table/columnComponents/CustomerMembershipType"
import { StatusOfPerformanceTest } from "components/table/columnComponents/StatusOfPerformanceTest"
import { StatusOfWork } from "components/table/columnComponents/StatusOfWork"

export const enterpriseMonitoringTableHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "Email",
    type: "sort-search",
    name: "email",
    size: "middle",
  },
  {
    title: "Work Status",
    type: "select",
    name: "work_status",
    size: "small",
    options: deviceWorkStatusOptions,
    cellComponent: StatusOfWork,
  },
  {
    title: "Status",
    type: "select",
    name: "perftest_status",
    size: "small",
    options: contractorMonitoringPerformanceTestStatusOptions,
    cellComponent: StatusOfPerformanceTest,
  },
  {
    title: "Contractor",
    type: "sort-search",
    name: "contractor_name",
    size: "middle",
  },
  {
    title: "Country",
    type: "sort-search",
    name: "country",
    size: "small",
  },
  {
    title: "Zip code",
    type: "sort-search",
    name: "zip_code",
    size: "small",
  },
  {
    title: "State",
    type: "sort-search",
    name: "state",
    size: "small",
  },
  {
    title: "City",
    type: "sort-search",
    name: "city",
    size: "middle",
  },
  {
    title: "Customer",
    type: "sort-search",
    name: "homeowner_name",
    size: "middle",
  },
  {
    title: "Thermostat S/N",
    type: "sort-search",
    name: "sn",
    size: "middle",
  },
  {
    title: "Activation date",
    type: "sort-date-range",
    name: "activation_date",
    size: "middle",
  },
  {
    title: "Address",
    type: "sort-search",
    name: "address",
  },
  {
    title: "Installation type",
    type: "select",
    size: "small",
    name: "installation_type",
    options: hvacOptions,
  },
  {
    title: "Alerts",
    type: "select",
    size: "small",
    name: "alerts",
    options: devicesAlertsOptions,
  },
  {
    title: "Membership",
    type: "select",
    size: "small",
    name: "membership",
    options: devicesMembershipOptions,
  },
  {
    title: "Membership type",
    type: "search",
    name: "membership_name",
    size: "middle",
    cellComponent: CustomerMembershipType,
  },
  {
    title: "Thermostat name",
    type: "sort-search",
    name: "name",
    size: "middle",
  },
  {
    title: "System type",
    type: "select",
    name: "system_type",
    size: "small",
    options: deviceSystemTypeOptions,
  },
  {
    title: "Accessories",
    type: "select",
    name: "accessories",
    size: "small",
    options: deviceAccessoriesOptions,
  },
  {
    title: "HVAC",
    type: "sort-search-number",
    name: "system_age",
    size: "small",
  },
]
